export default __webpack_public_path__ + "static/media/towerd.544aaaca.png";